import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { DDD,
        E2Data,
        mergeDDDIAndUI,
        getInvoiceValuesFromMergedDDDIAndUI,
        tx} from "../lib/ddd/ddd";
import Logo from "../components/menu/Logo";
import FormWizard from "../components/formWizardOverride/FormWizard";
//import "react-form-wizard-component/dist/style.css";
import { Row, Col, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import classes from "./IntegrationWizard.module.scss";
import JSONPretty from "../components/jsonPrettyOverride/JSONPretty";
import 'react-json-pretty/themes/monikai.css';
import Step from "../components/integrationWizard/Step/Step";
import ReturnDoc from "../components/integrationWizard/ReturnDoc/ReturnDoc";
import { OrgIdContext } from "../store/orgId_context";
import { UserUIStateContext } from "../store/userUIStateContext";
import LoadingDots from "../components/UI/LoadingDots";
import {allDocTypes} from "../components/objectPlaygroundComponents/saveInvoiceData";
import Curl from "../components/APIPlaygroundComponents/Curl";
import JsonObject from "../components/APIPlaygroundComponents/JsonObject";
import { GenericFormFields } from "../components/integrationWizard/form/GenericFormFields";
import { DetailsCollapse } from "../components/integrationWizard/detailsCollapse/DetailsCollapse";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ComplexityDescription } from "../components/integrationWizard/complexity/ComplexityDescription";
import { ComplexityAccordion } from "../components/integrationWizard/complexity/ComplexityAccordion";
import { useQuery } from "@tanstack/react-query";
import IntegrationOverview from "../components/integrationWizard/overview/IntegrationOverview";
import DataObjectIcon from '@mui/icons-material/DataObject';
import ReceiptIcon from '@mui/icons-material/Receipt';
import NumbersIcon from '@mui/icons-material/Numbers';
import ArticleIcon from '@mui/icons-material/Article';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from "../components/UI/Button";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { GenericTooltip } from "../components/integrationWizard/form/GenericTooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Ajv from "ajv";



const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const e2Data_EU_WorkflowSteps = new E2Data("EU_WorkflowSteps");
e2Data_EU_WorkflowSteps.orderBy = "Step";
e2Data_EU_WorkflowSteps.filter = 'UserAccessible=true'
const e2Data_EU_SCR = new E2Data("EU_SCR");
const ajv = new Ajv({allErrors: true});

const IntegrationWizard = () => {
    const [chosenPartial, setChosenPartial] = useState("Normal");
    const [isLoading, setIsLoading] = useState(false);
    const [newInvoiceData, setNewInvoiceData] = useState(null);
    const [mergedJson, setMergedJson] = useState(null);
    const [editorJson, setEditorJson] = useState(null);
    const [editorStepsJson, setEditorStepsJson] = useState(null);
    const [editorDocJson, setEditorDocJson] = useState(null);
    const [lastFieldChange, setLastFieldChange] = useState(null);
    const [lastFieldChangeIndex, setLastFieldChangeIndex] = useState(null);
    const [stepsInfo, setStepsInfo] = useState([]);
    const [stepsOnOff, setStepsOnOff] = useState({});
    const [docOnOff, setDocOnOff] = useState({});
    const [curlCommand, setCurlCommand] = useState("");
    const { connectionKey, integrationDevice, setConnKeyHandler, mainOrgId, mainOrgCountry } = useContext(OrgIdContext);
    //const { width } = useWindowSize();
    const formWizardRef = useRef(null);
    const [sendingRequestLoad, setSendingRequestLoad] = useState(false);
    const [response, setResponse] = useState(null);
    const [errorMsg, setErrorMsg] = useState();
    const [isErrored, setIsErrored] = useState(false);
    const [runConnectionKeyRequest, setRunConnectonKeyRequest] = useState(false);
    const [formValidation, setFormValidation] = useState(false);
    const [formErrorsText, setFormErrorsText] = useState();

    const {integrationWizardStep, 
        setIntegrationWizardStepHandler, 
        setIntegrationWizardFinishedHandler,
        integrationJson,
        setIntegrationJsonHandler,
        integrationSteps,
        setIntegrationStepsHanlder,
        integrationDocs,
        setIntegrationDocsHandler,
        saveValues
      } = useContext(UserUIStateContext);
      const [jsonsLoadedFromSaved, setJsonsLoadedFromSave] = useState(false);

    const {_details, ...mainForm} = mergedJson ? mergedJson : {};
    
    const {isPending : isMinimalPending, data : minimalData, error:minimalError, isError:isMinimalError} = useQuery({
      queryKey: ['APP_GetNewDDDIAndUIMerged', "Normal", "IncludeInfo", "EditableOnly"],
      queryFn: () => ddd.APP_GetNewDDDIAndUIMerged({Complexity: "Normal", IncludeInfo : true}, {Complexity: "Normal", EditableOnly: true}),
      staleTime: "Infinity"
    })

    const {isPending : isStepsPending, data : stepsData} = useQuery({
      queryKey: ['Data.GetEntityData', e2Data_EU_WorkflowSteps.GetParamsObject()],
      queryFn: () => e2Data_EU_WorkflowSteps.GetData(),
      staleTime: "Infinity",
      //enabled: false
    })

    const {isPending : isConnectionKeyPendng, data : connectionKeyData} = useQuery({
      queryKey: ["EUeInvoices.GetCurrentTData"],
      queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetCurrentTData"),
      //staleTime: "Infinity",
      enabled: runConnectionKeyRequest /*&& false*/
    })

    useEffect(() => {
      let everytingOk = true;
      if(integrationWizardStep>2){
        //TODO: Because we moved saving. The old integrationJsons won't be nested in Object subobject. We have to move them to beginning
        if(!integrationJson || !integrationJson.hasOwnProperty("Object")){
          everytingOk=false;
        }else{
          setEditorJson({...integrationJson})
        }
      }
      if(integrationWizardStep > 3){
        if(!integrationSteps || !integrationJson || !integrationJson.hasOwnProperty("Object")){
          everytingOk=false;
        }else{
          setEditorStepsJson({...integrationJson, Steps : [...integrationSteps], Complexity : "Normal"})
          loadStepsOnOff(integrationSteps);
        }
      }
      if(integrationWizardStep>4){
        if(!integrationDocs || !integrationJson || !integrationJson.hasOwnProperty("Object")){
          everytingOk=false;
        }else{
          setEditorDocJson({...integrationJson, Steps : [...integrationSteps], ReturnDoc :[...integrationDocs],  Complexity : "Normal"})
          loadDocsOnOff(integrationDocs);
        }
      }

      if(everytingOk && integrationWizardStep>0){
        setJsonsLoadedFromSave(true);
        formWizardRef.current.goToTab(integrationWizardStep-1);
      }
    }, [])

    useEffect(() => {
      if(!connectionKey)
        setRunConnectonKeyRequest(true);

      if(!isMinimalPending && minimalData){
        const {DDDI_GetNew, UI_GetNew} = minimalData;
        let deepClone = mergeDDDIAndUI(DDDI_GetNew.Invoice, UI_GetNew.Invoice);
        setIsLoading(false);
        setNewInvoiceData(DDDI_GetNew.Invoice);
        copySavedValues(deepClone);
        setMergedJson(deepClone);
        let invoiceWithValues = getInvoiceValuesFromMergedDDDIAndUI(deepClone);
        if(!integrationJson || !integrationJson.hasOwnProperty("Object")){
          //setEditorJson(invoiceWithValues);
          setEditorJson({"Object" : {...invoiceWithValues}, "Complexity" : "Normal"});
        }
      }
    }, [isMinimalPending, minimalData]);

    const copySavedValues = (deepClone) => {
      if(!integrationJson)
        return;
      //TODO: Because we transition from {Buyer, etc etc} to {Object: {buyer, etc etc}} We need to check both, until saved data is all overriden
      let temporary = integrationJson.hasOwnProperty("Object") ? integrationJson.Object : integrationJson;
      if(temporary){
        for(const [key, val] of Object.entries(temporary)){
          if(val !== null && deepClone.hasOwnProperty(key) && key !== "_details"){
            deepClone[key].Value = val;
          }
        }
      }
    }

    useEffect(() => {
      if(!isStepsPending && stepsData){
        setStepsInfo(stepsData?.result?.data||[])
      }
    }, [isStepsPending,stepsData]);

    useEffect(() => {
      if(!isConnectionKeyPendng && connectionKeyData){
        setConnKeyHandler(connectionKeyData?.result?.Result?.ConnectionKey)
      }
    }, [isConnectionKeyPendng,connectionKeyData]);

    const generateCurlCommand = useCallback((json) => {
      const jsonString = JSON.stringify(JSON.stringify(json));

      const curlCmd = tx(`curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.DDDI_Save -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${jsonString}`);
      setCurlCommand(curlCmd);
    }, [integrationDevice]);

    const handleComplete = () => {
      setIntegrationWizardFinishedHandler(true);
    };

    const validateForm = () =>{
      if(!formValidation)
        return true;

      const {DDDI_GetNew, UI_GetNew} = minimalData;
      const validate = ajv.compile(DDDI_GetNew.JSONSchema.properties.Invoice)
      const valid = validate(editorJson.Object)

      console.log(valid);
      if (!valid){
        console.log(validate.errors)
        //setFormErrorsText(JSON.stringify(validate.errors));
        //setFormErrorsText(<div>{validate.errors[0].dataPath} : {validate.errors[0].message}</div>)
        setFormErrorsText(validate.errors.map(item =>  {
          return(
            <div>{item.dataPath} : {item.message}</div>
          )
        }))
      }else{
        setFormErrorsText(null);
        return true;
      }
      /*const schema = {
        type: "object",
        properties: {
          foo: {type: "integer"},
          bar: {type: "string"}
        },
        required: ["foo"],
        additionalProperties: false
      }
      
      const validate1 = ajv.compile(schema)
      
      const data = {
        foo: 1,
        bar: null
      }
      
      const valid1 = validate1(data)
      if (!valid1) console.log(validate1.errors)*/
      return false;
    }

    const formErrors = () =>{
      //console.log("errors");
    }

    const tabChanged = useCallback(({prevIndex,nextIndex,}) => {
      let saveOnServer = {};
      if(integrationWizardStep === null || nextIndex > integrationWizardStep){
        setIntegrationWizardStepHandler(nextIndex, true);
        saveOnServer.integrationWizardStep = nextIndex;
      }
        
      if(nextIndex === 3){
        setIntegrationJsonHandler(editorJson, true);
        saveOnServer.integrationJson = editorJson || null;
        if(!editorStepsJson){
          setEditorStepsJson({...editorJson, Steps : [], Complexity : "Normal"})
        }else{
          setEditorStepsJson({...editorStepsJson, ...editorJson});
        }
      }else if(nextIndex===4){
        setIntegrationStepsHanlder(editorStepsJson.Steps || null, true);
        saveOnServer.integrationSteps = editorStepsJson.Steps || null;
        if(!editorDocJson){
          setEditorDocJson({...editorStepsJson, ReturnDoc : []})
        }else{
          setEditorDocJson({...editorDocJson, ...editorJson, Steps : editorStepsJson.Steps})
        }
      }else if(nextIndex===5){
        setIntegrationDocsHandler(editorDocJson.ReturnDoc || null, true);
        saveOnServer.integrationDocs = editorDocJson.ReturnDoc || null;

        setLastFieldChange(null);
        generateCurlCommand(editorDocJson);
        /*setSendingRequestLoad(true);


        ddd.getRpcClient().config.headers = {};
        ddd.getRpcClient().config.headers['Authorization'] = `IoT ${connectionKey}:EUeInvoices`;
        ddd.getRpcClient().config.headers['D3Pro-PreferAuthorizationOverSession'] = `True`;
        ddd.DDDI_Save(editorDocJson).then((res) => {
          setSendingRequestLoad(false);
          console.log(res);
          setResponse(res);
        });*/
      }
      saveValues(saveOnServer);
    }, [editorStepsJson, editorJson, editorDocJson, generateCurlCommand]);

    const filterObject = (obj) => {
        let invoiceWithValues = getInvoiceValuesFromMergedDDDIAndUI(obj);

        setEditorJson({"Object" : {...invoiceWithValues}, "Complexity" : "Normal"});
    }

    const onAddDetailClick = (detail) =>{
      if(!mergedJson["_details"][detail] || mergedJson["_details"][detail].length ===0)
        return;
      
      mergedJson["_details"][detail].push(createNewDetailObject(detail));
      setMergedJson({...mergedJson});
      filterObject(mergedJson);
    }

    const onRemoveDetailClick = (detail, index) => {
      mergedJson["_details"][detail].splice(index, 1);
      setMergedJson({...mergedJson});
      filterObject(mergedJson);
    }

    const createNewDetailObject = (detail) =>{
      let ret = JSON.parse(JSON.stringify(mergedJson["_details"][detail][0]));
      for(let fieldName in ret){
        ret[fieldName].Value = ret[fieldName].defaultValue;
      }

      return ret;
    }

    function updateValueByKey(obj, key, index, newValue) {
        for (let prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            if (prop === key) {
              obj[prop].Value = newValue;
              setMergedJson(obj);
              filterObject(obj);
              return;
            }
          }
        }
        for (let prop in obj["_details"]) {
          for (let subObj = 0; subObj < obj["_details"][prop].length; subObj++) {
            if (index) {
              subObj = index;
            }
            for (let subKey in obj["_details"][prop][subObj]) {
              if (subKey === key) {
                obj["_details"][prop][subObj][subKey].Value = newValue;
                setMergedJson(obj);
                filterObject(obj);
                return;
              }
            }
          }
        }
    }

    const updateValueByKey1 = (obj, key, value, detail, index) => {
      if(obj.hasOwnProperty(key)){
        obj[key].Value = value;
      }

      if(detail && obj["_details"][detail] && obj["_details"][detail][index]){
        updateValueByKey1(obj["_details"][detail][index], key, value);
      }
    }

    const handleFieldChange1 = (fieldName, value, {fieldConfig, detail, index, e}) =>{
      setLastFieldChangeIndex(isNaN(index) ? null : index);
      setLastFieldChange(fieldName);
      updateValueByKey1(mergedJson, fieldName, value, detail, index);
      setMergedJson(mergedJson);
      filterObject(mergedJson);
      setTimeout((counter, field) => {
        document.getElementById("wizardFormScroll")?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
      }, 500)
    }

    const onStepChanged = (step, value) => {
      let newSteps = {...stepsOnOff, [step]:value};
      setStepsOnOff(newSteps);
      setLastFieldChangeIndex(null);
      loadStepsToEditorJson(newSteps);
      setLastFieldChange("Steps");
      setTimeout(() => {
        document.getElementById("stepsFormScroll")?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      }, 500)
    }

    const loadStepsOnOff = (steps) =>{
      if(!steps)
        return;
      let n = {};
      steps.forEach(step => n[step] = true)
      setStepsOnOff(n);
    }
    /**
     * @param {object} steps {stepNum<string> : value<boolean>}
     */
    const loadStepsToEditorJson = (stepsObj) =>{
      let steps = [];
      for(var step in stepsObj){
        if(stepsObj[step])
          steps.push(parseInt(step))
      }
      setEditorStepsJson({...editorStepsJson, Steps : steps});
    }

    const loadDocsOnOff = (docs) =>{
      if(!docs)
        return;
      let n = {};
      docs.forEach(step => n[step] = true)
      setDocOnOff(n);
    }

    const onDocChanged = (doc, value) => {
      let newDocs = {...docOnOff, [doc] : value};
      setDocOnOff(newDocs);
      loadDocsToEditorJson(newDocs);
      setLastFieldChangeIndex(null);
      setLastFieldChange("ReturnDoc");
      setTimeout(() => {
        document.getElementById("returnDocumentScroll")?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      }, 500)
    }
    /**
     * @param {object} steps {doc<string> : value<boolean>}
     */
    const loadDocsToEditorJson = (docObj) => {
      let documents = [];
      for(var doc in docObj){
        if(docObj[doc])
        documents.push(doc)
      }
      setEditorDocJson({...editorDocJson, ReturnDoc : documents});
    }

    const loadStates = () => {
      e2Data_EU_WorkflowSteps.GetData().then((res) => {
        setStepsInfo(res?.result?.data||[])
      });
      e2Data_EU_SCR.filter = `CountryCode='${mainOrgCountry}'`;
      e2Data_EU_SCR.GetData().then((res) => {
        
      })
    }

    const executeJsonCommand = () =>{
      setSendingRequestLoad(true);
      setResponse("");

      ddd.getRpcClient().config.headers = {};
      //ddd.getRpcClient().config.headers['Authorization'] = `IoT ${connectionKey}:EUeInvoices`;
      //ddd.getRpcClient().config.headers['D3Pro-PreferAuthorizationOverSession'] = `True`;
      ddd.DDDI_Save(editorDocJson).then((res) => {
        setSendingRequestLoad(false);
        console.log(res);
        setResponse(res);
      });
    }
    
    
    return(
        <>
        <Helmet>
            <title>Integration | DDD Invoices</title>
        </Helmet>
        <div className={`w-100 ${classes.container} ${classes["p-lrb-5"]}`}>

              <main>
                {/*<div className="d-flex justify-content-center">
                  <Logo />
                  <div className="d-flex flex-row align-items-center" style={{paddingLeft: "15px"}}>
                    <h2 className="text-center">Integration</h2>
                  </div>
</div>*/}
                {/*<div className="text-center">
                    <Logo />
                    <h2>Integration</h2>
</div>*/}
                <div className="row g-5">
                    <FormWizard
                    onComplete={handleComplete}
                    onTabChange={tabChanged}
                    ref={formWizardRef}
                    >
                    <FormWizard.TabContent title="Overview" icon="ti-credit-card" >
                      <IntegrationOverview/>
                    </FormWizard.TabContent>
                    <FormWizard.TabContent 
                      title="Invoice" 
                      icon="ti-credit-card" 
                      _isValid = {validateForm}
                      _onValidationError = {formErrors}
                      >
 {isMinimalPending && (<>
                      <LoadingDots />
 </>)}
{!isMinimalPending && !isErrored && (<>   
                        <Row className = "g-5">
                            <Col className="col-md-5">
                                <div className={classes["titleRows"]}>
                                  <span><h3><ReceiptIcon/>Enter invoice data</h3></span>
                                  <div className={classes["wizard-text"]}>Here, you can enter your invoice information. The information you write will be reflected on the right in the preview object. Note! The amount of information your invoice requires is controlled by the "Complexity" parameter. We'll learn how to pass more information about your invoices when we talk about "Complexity".
                                  </div>
                                </div>
                                <div style={{display:"flex", justifyContent:"space-between"}}>
                                  <label>Enable form validation 
                                    <GenericTooltip tooltip={"If enabled, this validation occurs only on client side. Its purpose is only to ease your entry of information in the form below."} fieldName={"validationOffon"} />
                                  </label>
                                  {formErrorsText && 
                                    <div style={{color:"red"}}>
                                      Errors 
                                      <OverlayTrigger placement="left" overlay={<Tooltip>{formErrorsText}</Tooltip>}>
                                          <ErrorOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"red"}}/>
                                      </OverlayTrigger>
                                  </div>}
                                  <div className="form-check form-switch text-center">
                                  <input className="form-check-input" style={{float:"none"}} type="checkbox" role="switch" checked={formValidation} onChange={() =>setFormValidation(val => !val)}/>
                                  </div>
                                </div>
                                <div className={classes["form-wrapper"]}>
                                  <form>
                                    {mergedJson &&
                                    <>
                                      <GenericFormFields fieldInfo={mainForm} onFieldChange={handleFieldChange1} showFieldName={true}></GenericFormFields>
                                    </>
                                    }
                                    {_details &&
                                      Object.entries(_details).map(([detail, forms]) => {
                                        return (
                                          <DetailsCollapse detail={detail} forms={forms} opened={true} onAddClick={onAddDetailClick}>
                                            {forms.map((form, index) => {
                                              return (<div key={detail+index} className={classes["detail"]}>
                                                {forms.length > 1 && 
                                                  <div style={{textAlign:"left"}}>
                                                    <i className={`${classes["detailCloseBtn"]} ti-close`} onClick={() => onRemoveDetailClick(detail, index)}></i>
                                                  </div>
                                                }
                                                  <GenericFormFields fieldInfo={form} onFieldChange={handleFieldChange1} showFieldName={true} className={classes["detailRows"]} detail={detail} index={index}></GenericFormFields>
                                                  
                                              </div>)
                                            })}
                                          </DetailsCollapse>
                                        )
                                      })
                                    }
                                  </form>
                                </div>
                                
                            </Col>
                            <Col className="my-auto p-0 m-0">
                                  <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
                            </Col>
                            <Col className="col-md-6 order-md-last">
                              <div className={classes["titleRows"]}>
                                  <span><h3><DataObjectIcon/>Object preview</h3></span>
                                  <div className={classes["wizard-text"]}>This is Object preview. At this moment, we're only learning about the basic information needed for an invoice, so we're only building the Object keyword.
                                      As we move on, we will add other information (Steps and ReturnDoc).<br/><br/><br/>
                                      
                                  </div>
                                </div>
                                <div className={classes["form-wrapper"]} style={{textAlign : "left"}}>
                                    <JSONPretty data={editorJson} fieldName={lastFieldChange} fieldIndex={lastFieldChangeIndex} idToScroll="wizardFormScroll"></JSONPretty>
                                </div>
                            </Col>
                        </Row>
                        </>
)}
                    </FormWizard.TabContent>
                    <FormWizard.TabContent title="Steps" icon="ti-settings">
                      {isStepsPending && <LoadingDots/>}
{!isStepsPending &&                    
                        <Row className = "g-5">
                            <Col className="col-md-5">
                              <div className={classes["titleRows"]}>
                                <span><h3><NumbersIcon/>Select steps</h3></span>
                                <div className={classes["wizard-text"]}>What operations do we wish to be executed on your invoice data? Each step has a code number in the corner that we will send. What you select will be reflected on the right in Object preview.
                                
                                </div>
                              </div>
                              <div className={classes["steps-wrapper"]}>
                                {stepsInfo.map((step, index) => 
                                  <Step key={step.Id} checked = {stepsOnOff[step.Step]} onStepChange={onStepChanged} stepNumber={step.Step} stepShortDescription={step.StepDescription} stepLongDescription={step.StepUIDescription}></Step>
                                
                                )}
                              </div>
                            </Col>
                            <Col className="my-auto p-0 m-0">
                                  <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
                            </Col>
                            <Col className="col-md-6 order-md-last">
                              <div className={classes["titleRows"]}>
                                <span><h3><DataObjectIcon/>Object preview</h3></span>
                                  <div className={classes["wizard-text"]}>Here, we added our new array parameter "Steps" to the object. In it, we will fill step codes. Both strings and integers are accepted.
                                  <br/><br/>
                                </div>
                              </div>
                                <div className={classes["form-wrapper"]} style={{textAlign : "left"}}>
                                    <JSONPretty data={editorStepsJson} fieldName={lastFieldChange} idToScroll="stepsFormScroll"></JSONPretty>
                                </div>
                            </Col>
                        </Row>
}
                    </FormWizard.TabContent>
                    <FormWizard.TabContent title="Return documents" icon="ti-check">
                    <Row className = "g-5">
                            <Col className="col-md-4">
                              <div className={classes["titleRows"]}>
                                <span><h4><ArticleIcon/>Select returned documents</h4></span>
                                <div className={classes["wizard-text"]}>Select which documents you wish to be returned upon successful invoice execution
                                </div>
                              </div>
                              <div className={classes["steps-wrapper"]}>
                                {allDocTypes.map((doc) => 
                                  <ReturnDoc key={doc.doc} doc={doc.doc} checked={docOnOff[doc.doc]} onDocChange={onDocChanged} stepShortDescription={doc.doc} stepLongDescription={doc.description}></ReturnDoc>
                                    )}
                              </div>
                            </Col>
                            <Col className="my-auto p-0 m-0">
                                  <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
                            </Col>
                            <Col className="col-md-7 order-md-last">
                              <div className={classes["titleRows"]}>
                                <span><h3><DataObjectIcon/>Object preview</h3></span>
                                  <div className={classes["wizard-text"]}>Here, we added another object parameter called "ReturnDoc"
                                  <br/><br/>
                                </div>
                              </div>
                                <div className={classes["form-wrapper"]} style={{textAlign : "left"}}>
                                    <JSONPretty data={editorDocJson} fieldName={lastFieldChange} idToScroll="returnDocumentScroll"></JSONPretty>
                                </div>
                            </Col>
                        </Row>
                    </FormWizard.TabContent>
                    <FormWizard.TabContent title="Execute" icon="ti-cloud-up">
                      <Row className = "g-5">
                          <Col className="col-md-6 order-md-last">
                            <div className={classes["steps-wrapper"]}>
                              The object is ready to be send to our API. Click execute to get a response.
                              {/* {sendingRequestLoad && (<h3>Executing...</h3>)}
                              {!sendingRequestLoad && (<h3>Executed</h3>)} */}
                              <Curl
                                currentCurl={curlCommand}
                                currentJson={editorDocJson}
                                activeApi="DDDI_Save"
                              />
                              <Button style={{fontSize:"2rem", marginTop:"1rem", marginBottom:"1rem"}} onClick={executeJsonCommand}><CloudUploadIcon style={{marginRight:"1rem"}}/>Execute</Button>
                              {sendingRequestLoad && (<LoadingDots />)}
                              {!sendingRequestLoad && response!==null && (
                                <div style={{textAlign : "left", paddingTop : "5px"}}>
                                  <JsonObject response={response} />
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col className="col-md-6">
                              <div className={classes["form-wrapper"]} style={{textAlign : "left"}}>
                                  <JSONPretty data={editorDocJson} fieldName={lastFieldChange} idToScroll="sendingObjectWizardScroll"></JSONPretty>
                              </div>
                          </Col>
                      </Row>
                    </FormWizard.TabContent>
                    {/* <FormWizard.TabContent title="Complexity" icon="ti-cloud-up">
                      <ComplexityAccordion connectionKey={connectionKey} initialInvoiceObj={newInvoiceData}></ComplexityAccordion>
                    </FormWizard.TabContent> */}
                    </FormWizard>
                    <style>{`
                      @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
                    `}</style>
                </div>
            </main>

{isErrored && process.env.REACT_APP_API_ENDPOINT && <>
<div>{errorMsg}</div>
</>}
{isMinimalError &&<>
<div>{minimalError}</div></>}
        </div>
</>
    );
}

export default IntegrationWizard;